export default "__VITE_ASSET__BUv1TFcy__"